const AU = {
  governmentalOrganization: [
    "corporate Commonwealth entity",
    "corporate Commonwealth company"
  ],
  listedPublicCompany: [
    "public company limited by shares",
    "public company limited by guarantee",
    "no liability company"
  ],
  nonProfit: [
    "public benevolent institution (PBI)",
    "health promotion charity (HPC)",
    "companies limited by guarantee"
  ],
  privateCompany: [
    "proprietary limited company (Pty Ltd)",
    "unlimited proprietary (Pty)"
  ]
};
export {
  AU as default
};
